import styled from "styled-components";
import { IconName } from "interfaces/icons";
import { MAIN_THEME } from "styles/colors";
import dayjs from "dayjs";
import Icon from "./Icon";

const Title = styled.p`
	margin-left: 11px;
	text-transform: uppercase;
	font-size: 14px;
`;

const Container = styled.button`
	min-width: 170px;
	height: 38px;
	background: ${MAIN_THEME.DARK_BG_TERTIARY};
	border-radius: 50px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 16px;
	font-family: "Open Sans Medium", sans-serif;
	font-size: 16px;
	color: ${MAIN_THEME.TEXT_PRIMARY};
	letter-spacing: 0.03em;
	border: 1px solid ${MAIN_THEME.BORDER_COLOR};
	outline: none;
	cursor: pointer;
	transition: background-color 0.2s ease;

	&:hover {
		background: ${MAIN_THEME.DARK_BG_SECONDARY};
	}
`;

interface Props {
	onClick: () => void;
	dateRange: { dateFrom: string | null; dateTo: string | null };
}

const FilterButton = (props: Props): JSX.Element => {
	const { onClick, dateRange } = props;

	const formatDate = (dateFrom: string, dateTo: string) => {
		const fromDate = dayjs(dateFrom);
		const toDate = dayjs(dateTo);

		if (fromDate.isSame(toDate, "year")) {
			if (fromDate.isSame(toDate, "month")) {
				return `${fromDate.format("D")}-${toDate.format(
					"D"
				)}, ${fromDate.format("MMM, YYYY")}`;
			}

				return `${fromDate.format("D")}-${toDate.format(
					"D"
				)}, ${fromDate.format("MMM, YYYY")}`;

		}

		return `${fromDate.format("D MMM, YYYY")} - ${toDate.format(
			"D MMM, YYYY"
		)}`;
	};

	const formattedDate = formatDate(
		dateRange.dateFrom || "",
		dateRange.dateTo || ""
	);

	return (
		<Container onClick={onClick}>
			<Icon name={IconName.FILTER} color="#ffffff" size={16} />
			<Title>{formattedDate}</Title>
		</Container>
	);
};

export default FilterButton;
